<template>
  <main class="dashboard p-1 sm:p-4" v-loading="false">
    <!-- //START of top search section -->
    <div class="flex items-center py-3">
      <div class="md:w-6/12 w-full">
        <h2 class="dashboard-header">Dashboard Overview</h2>
      </div>
    </div>
    <!-- //End of top search section -->

    <!-- <StarsWrapper @onChange="startValue"/> -->

    <section class="mt-12 shadow-md rounded-xl">
      <!-- //--START  section for truck section -->
      <div class="flex items-center p-3 px-4">
        <div class="md:w-6/12 w-full">
          <h2 class="dashboard-header">
            {{ user.firstname }} {{ user.lastname }}
          </h2>
        </div>
        <div class="md:w-6/12 w-full flex justify-end">
          <img src="@/assets/images/onboarding/Logistics-rafiki 1.svg" />
        </div>
      </div>
      <!-- //--END  section for truck section -->

      <!-- //--START  section for banner section -->
      <div v-if="banners && banners.shipper_web_promo_image && banners.isActive" class="banner_wrapper">
        <img src="./assets//bammer_img.png" class="layer_bg" />
        <div class="flex justify-between gap-3 relative">
          <div class="banner_content">
            <b class="b_text">{{ banners.name || "" }}</b>
            <p class="p_text">{{ banners.description || "" }}</p>
            <div class="flex gap-3  items-center mt-3">
              <div>
                <img class="clock_img" src="./assets/clock.png" />
              </div>
              <div>
                <p class="date_wrapper">Valid From <b> {{ formatDate(banners.startDate) }}</b></p>
                <p class="date_wrapper">to <b> {{ formatDate(banners.endDate) }}</b></p>
              </div>
            </div>
          </div>
          <div class="hidden_goody_bag">
            <img :src="banners && banners.shipper_web_promo_image ? banners.shipper_web_promo_image : ''"
              class="w-full object-contain" />
          </div>
        </div>
      </div>
      <!-- //--END  section for banner section -->

      <!-- //--START  section for top-header -->
      <div class="flex items-center flex-wrap">
        <div
          class="MD-section sm:w-4/12 w-full sm:border-r-2 border-b-2 bg-primary-navy rounded-tl-3xl rounded-tr-3xl sm:rounded-none"
          ref="activeBooking">
          <h2 class="text-3xl font-bold">{{ overviewData.activeCount }}</h2>
          <span class="flex justify-center items-center cursor-pointer relative">
            <span :contenteditable="true" @click="activeContent = !activeContent"
              class="flex justify-center items-center outline-none">
              <abbr :contenteditable="false"> Active Shipments</abbr>
              <abbr class="ml-2 inline-block duration-100" :class="[activeContent ? 'turn-up' : 'turn-off']">
                <ArrowDown />
              </abbr>
            </span>

            <ActiveShipmentDPVue :incoming="overviewData.incoming" :outgoing="overviewData.outgoing"
              v-if="activeContent" />
          </span>
        </div>
        <div class="MD-section sm:w-4/12 bg-primary-navy w-full sm:border-r-2 border-b-2">
          <h2 class="text-3xl font-bold">{{ overviewData.scheduledCount }}</h2>
          <span>Scheduled Shipments</span>
        </div>
        <div class="MD-section sm:w-4/12 bg-primary-navy w-full sm:border-r-2 border-b-2">
          <h2 class="text-3xl font-bold">{{ overviewData.qouteCount }}</h2>
          <span>Quotes</span>
        </div>
      </div>
      <!-- //--END  section for top-header -->

      <!-- //--START  section for icoms -->
      <div class="flex items-center py-20 flex-wrap justify-center z-10">
        <div class="IC-section md:w-3/12 cursor-pointer w-6/12">
          <div class="w-full flex justify-center pb-2" @click="openBookingModal">
            <img src="@/assets/images/ondemand/book-shippment.svg" />
          </div>
          <span>Book Shipment</span>
        </div>

        <div @click="$router.push('/active-bookings')" class="IC-section md:w-3/12 cursor-pointer w-6/12">
          <div class="w-full flex justify-center pb-2">
            <img src="@/assets/images/ondemand/track-shipment.svg" />
          </div>
          <span>Track Shipments</span>
        </div>

        <div class="IC-section md:w-3/12 cursor-pointer w-6/12" @click="$router.push('/quote-draft')">
          <div class="w-full flex justify-center pb-2">
            <img src="@/assets/images/ondemand/get-quote.svg" />
          </div>
          <span>Get a Quote</span>
        </div>

        <div class="IC-section md:w-3/12 cursor-pointer  w-6/12"
          @click="$router.push('/settings/payment')"
          v-if="$store.state.authentication.env == 'development'">
          <div class="w-full flex justify-center pb-2">
            <img src="@/assets/images/ondemand/manage-payment.svg" />
          </div>
          <span>Manage Payments</span>
        </div>
      </div>
      <!-- //--END  section for icoms -->

      <NewBookinfModal :showModal="showNewBookingModal" @close-modal="showNewBookingModal = false" />
    </section>
  </main>
</template>

<script>
import ArrowDown from "@/assets/images/icons/ArrowDown";
import moment from "moment";
import NewBookinfModal from "../Bookings/modals/NewBookinfModal.vue";
// import StarsWrapper from "@/components/Ondemand/Rating/widget/StarsWrapper.vue";
import ActiveShipmentDPVue from "./module/ActiveShipmentDP.vue";

export default {
  components: { ArrowDown, ActiveShipmentDPVue, NewBookinfModal },

  data() {
    return {
      activeContent: false,
      estimate: 0.0,
      overviewData: {},
      newEstimate: {
        // address: {
        //   name: "",
        //   lat: 6.123,
        //   lng: 3.456,
        // },
        takeoff: "",
        delivery: "",
        shipmentType: "package",
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        apiKey: "AIzaSyAys4Gc-dGXZmLn_zvNPMie_7d6oZicCuQ",
        quantity: 0,
      },
      showModal: false,
      showNewBookingModal: false,
      shipmentLayout: "card",
      isSelectShipmentLayout: false,
      bookings: [],
      firstTwoBookings: [],
      bookingAnalytics: {},
      activeShipmentsData: {},
      topDestinationsData: {},
      shipmentMetrics: {},
      loading: false,
      requestLoading: false,
      banners: []
    };
  },

  mounted() {
    this.getBookingAnalytics();
    this.getTotalActiveShipping();
    this.getDashboardOverview();
    this.getBanners()
    this.outSideClick(this.$refs.activeBooking, () => {
      this.activeContent = false;
    });
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    payload() {
      return {
        type: "shipper",
        userId: this.$store.getters.userId,
      }
    }
  },
  methods: {
    openBookingModal() {
      this.showNewBookingModal = true
    },
    formatDate(dateString) {
      return moment(dateString).format("MMMM Do, YYYY")
    },
    async getBanners() {
      try {
        let response = await this.$_getBanners(this.payload);
        this.banners = (response?.data?.data?.discounts || [])[0];
      } catch (error) {
        //
      }
    },
    async getDashboardOverview() {
      try {
        const response = await this.$_getDashboardOverview(
          localStorage.getItem("userId")
        );
        this.overviewData = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    getTakeOff(addressData) {
      this.newEstimate.takeoff = addressData.route;
      // this.newEstimate.address.name = addressData.route;
      // this.newEstimate.address.lat = addressData.latitude;
      // this.newEstimate.address.lng = addressData.longitude;
    },
    getDelivery(addressData) {
      this.newEstimate.delivery = addressData.route;
      // this.newEstimate.address.name = addressData.route;
      // this.newEstimate.address.lat = addressData.latitude;
      // this.newEstimate.address.lng = addressData.longitude;
    },
    async getEstimate() {
      this.requestLoading = true;
      try {
        const response = await this.$_estimateD(this.newEstimate);
        this.requestLoading = false;
        this.log(response);
        this.estimate = response.data.data.estimate;
        this.generateToast(`Estimated ₦ ${this.estimate}`, "success");
      } catch (error) {
        this.requestLoading = false;
        this.handleError(error);
      }
    },
    async getTotalActiveShipping() {
      try {
        let response = await this.$_getUserTotalShipping({
          userId: localStorage.getItem("userId"),
        });
        this.log(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getBookingAnalytics() {
      this.loading = true;
      try {
        const response = await this.$_getBookingAnalytics({ userId: this.$store.getters.userId });
        let { data } = response.data;
        this.topDestinationsData = data.destinationChart;
        this.activeShipmentsData = data.deliveryChart;
        this.bookings = data.allShippings;
        this.shipmentMetrics = data.shipmentMetric;
        // this.bookings = response.data.data.allShippings;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    formatEstimate(val) {
      return Number.parseFloat(val).toLocaleString();
    },
    disabled() {
      return false;
      // return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.hidden_goody_bag {
  @apply hidden sm:block h-full absolute right-0 top-0;

  img {
    @apply h-[170%] relative -top-[35%]
  }
}

.layer_bg {
  @apply absolute top-0 w-full h-full object-cover top-0 left-0 opacity-10
}

.clock_img {
  @apply w-[58px] [transform:rotateY(180deg)];
}

.date_wrapper {
  @apply font-[200] uppercase mb-[2px] text-gray-300;

  b {
    @apply font-semibold capitalize text-white
  }
}

.banner_content {
  .b_text {
    @apply text-2xl font-semibold
  }

  .p_text {
    @apply mt-2
  }
}

.banner_wrapper {
  @apply w-full mb-5 rounded-2xl bg-primary-navy p-4 sm:px-6 text-white relative;
}

.banner_img {
  @apply w-[2400px] object-cover rounded-2xl;
}

.dashboard-header {
  @apply py-2;
  font-size: 24px;
}

.dashboard {
  @apply bg-white pb-24;
}

.MD-section {
  @apply text-center bg-primary-navy text-white py-6 border-gray-500;
}

.IC-section {
  @apply text-center mb-8;
}

.turn-up {
  transform: rotateZ(180deg);
}

.turn-off {
  transform: rotateZ(0deg);
}
</style>